import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IEmail} from '../model/interface/email.model.interface';
import {FormControl, Validators} from '@angular/forms';
import {CustomerEmailService} from '../../core/services/customer-email.service';
import {EventBusService} from '../../core/services/event-bus.service';
import {DictionaryPosition} from '../model/dictionary.model';

@Component({
  selector: 'app-customer-email',
  templateUrl: './customer-email.component.html',
  styleUrls: ['./customer-email.component.css']
})
export class CustomerEmailComponent implements OnInit {
  @Input() email: IEmail;
  @Output() deleteEvent = new EventEmitter<IEmail>();
  @Output() editEvent = new EventEmitter<IEmail>();

  emailForm: FormControl;

  constructor(private customerEmailService: CustomerEmailService,
              private eventBusService: EventBusService) {
  }

  ngOnInit(): void {
    this.createForm();
  }

  editEmail() {
    return this.customerEmailService.edit(this.email.id, this.emailForm.value)
      .subscribe(() => {
        this.eventBusService.display(DictionaryPosition.OK);
        this.editEvent.next(this.email);
      });
  }

  deleteEmail() {
    return this.customerEmailService.delete(this.email.id)
      .subscribe(() => {
        this.eventBusService.display(DictionaryPosition.OK);
        this.deleteEvent.next(this.email);
      });
  }

  private createForm() {
    this.emailForm = new FormControl(this.email.email, Validators.email);
  }
}
